import { define, html, router } from "hybrids";

export interface VBroadcastNavBar {
  back: boolean;
  close: boolean;
}

export default define<VBroadcastNavBar>({
  tag: "v-broadcast-nav-bar",
  back: false,
  close: false,
  render: ({ back, close }) => html`
    ${back &&
    html`<v-ui-button
      href="${router.backUrl({ nested: true })}"
      icon="back"
      variant="outline"
    ></v-ui-button>`}
    <v-ui-text variant="h2" weight="semibold">
      <slot></slot>
    </v-ui-text>
    ${close &&
    html`
      <v-ui-button
        class="close"
        href="${router.backUrl()}"
        icon="close"
        variant="outline"
      ></v-ui-button>
    `}
  `.css`
    :host {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      height: 36px;
    }

    v-ui-button {
      min-width: 36px;
      width: 36px;
      padding: 0;
      margin-right: var(--v-broadcast-layout-spacing);
    }

    v-ui-button.close {
      margin-right: 0;
    }

    v-ui-text {
      flex-grow: 1;
    }
  `,
});
